
// This is an auto generated file - do not edit!
// Swagger path: /api/LogicStep/{code}/parameter/{parameter}/values

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService } from '../base-api.service';
import {
    LogicStepOption, SystemEntity
} from '@wdx/clmi/clmi-swagger-gen';
import { HttpParams } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class LogicstepCodeParameterParameterValuesApiService extends BaseApiService {
    
    get(code: string, parameter: string, entityType?: SystemEntity, options = {}): Observable<LogicStepOption[]> {
        let params = new HttpParams();
        if(entityType !== undefined) {
            params = params.append('entityType', entityType);
        }

        return this._get<LogicStepOption[]>(
            `/LogicStep/${code}/parameter/${parameter}/values`, {
                ...options,
                params,
            }
        );
    }
}
